// extracted by mini-css-extract-plugin
export default {"container":"Feedback_container__YqhGH","leftContainer":"Feedback_leftContainer__2wsg2","rightContainer":"Feedback_rightContainer__kxae4"};